import { memo, useCallback } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const Back = ({
  id = "btn-back",
  title,
  icon = <ArrowLeftOutlined />,
  type = "primary",
  onClick,
  noTitle = false,
  ...props
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const btnTitle = title ? title : t("button.back");

  const backHandler = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <Button
      className="bg-orange1 border-none hover:opacity-70"
      id={id}
      type={type}
      icon={icon}
      onClick={onClick || backHandler}
      {...props}
    >
      {noTitle ? null : btnTitle}
    </Button>
  );
};

export default memo(Back);
